import React, { Component } from 'react';
import axios from 'axios';
import { withRouter, Link } from 'react-router-dom';
import constClass from '../../Constants/Constants';
import Loading from '../Loading/Loading';
import util from 'util';
import moment from 'moment';
import BookModal from '../Common/BookModal';
import BookCancelModal from '../Common/BookCancelModal';
import BookCancelFinModal from '../Common/BookCancelFinModal';
import 'moment/locale/ja';
import Common from '../Common/common';
import CommonBooking from '../Common/common_booking';
import ScrollToTop from '../Scroll/ScrollToTop';
import Payment from '../Payment/Payment';
import BookingCancel from './BookingCancel';
import BookingDetailView from './BookingDetailView';
import icon_back from '../Images/icon_back.svg';
import icon_count from '../Images/icon_count.svg';
import memoizeOne from 'memoize-one';

class Booking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      NowDate: '',
      sleeping: false,
      ready: false,
      disabled: false,
      siteId: isFinite(this.props.siteId) ? this.props.siteId : 0,
      ticketId: isFinite(this.props.ticketId) ? this.props.ticketId : 0,
      book_id: null,
      book_set_id: null,
      ticketMaster: null,
      ticketdetailMaster: null,
      attentionmodalflag: true,
      modalflag: false,
      cancelmodalflag: false,
      cancelmodalfinflag: false,
      inputCount: 1,
      selectedEntry: '',
      selectedExit: '',
      book_detail: {
        detail_type: '',
        entry_type: '',
        entry_data: '',
      },
      ticketid: null,
      bookDateList: null,
      customer_detail: null,
      bookingList: null,
      set_booking: {
        book_id: null,
        book_date: null,
        total: 0,
        customer_id: null,
        customer_name: '',
        customer_kana: '',
        customer_address: '',
        gender: '',
        birth: '',
        postal_code: '',
        card_no: '',
        phone_number: '',
        privacy_policy: constClass.FLAG.OFF,
      },
      set_booking_detail: [],
      set_bookCalList: null,
      set_bookCalListMessage: null,
      my_customer: {
        customer_id: null,
        customer_name: '',
        customer_kana: '',
        customer_address: '',
        gender: '',
        birth: '',
        postal_code: '',
        nearest_station: '',
        card_no: '',
      },
      activeIndex: 0,
      bookCalList: null,
      bookCalListMessage: null,
      recept: null,
      change: false,
      user_modal_flag: false,
      user_modal_read: false,
      bookingDetailList: null,
      bookDetailList: null,
      cancel_modal_flag: false,
      currentTime: this.getCurrentTime(),
      initialQs: null,
      modalData: {
        siteId: null,
        bookId: null,
        bookDate: null,
        count: null,
        refundTotal: null,
        entry_name: null,
        entrynote: null,
        entryName: null,
        total: null,
      },
      payment_data: {},
      customer_detail_type: [],
      selectedDetail: [],
    }
    this.modalStyle = {
      overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: "rgba(0,0,0,0.5)"
      },
      content: {
        position: "absolute",
        left: '0.5rem',
        right: '0.5rem',
        top: '50%',
        bottom: 'auto',
        marginTop: '-25%',
        borderRadius: "0rem",
        padding: "0px",
        height: "auto"
      }
    };
    this.intervalId = null;
    this.setReady = this.setReady.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.refreshBookData = this.refreshBookData.bind(this);
    this.changeCustomer = this.changeCustomer.bind(this);
    this.changeCustomerDetail = this.changeCustomerDetail.bind(this);
    this.backPayment = this.backPayment.bind(this);
    this.returnPayment = this.returnPayment.bind(this);
    this.submitCurrentbooking = this.submitCurrentbooking.bind(this);
    this.pageRef = React.createRef();
    this.handleIncrement = this.handleIncrement.bind(this);
    this.handleDecrement = this.handleDecrement.bind(this);
    this.handleDetailChange = this.handleDetailChange.bind(this);
    this.historyBack = this.historyBack.bind(this);
    this.renderHeaderMemo = memoizeOne((page, onBack) => {
      const showBack = page !== constClass.USER;
      const title = (() => {
        switch (page) {
          case constClass.USER:
          case constClass.USERCONFIRMATION: return 'お客様情報';
          case constClass.INPUTALERT: return '注意事項';
          case constClass.BINSELECT: return '新規予約';
          case constClass.INPUT:
          case constClass.INPUTBIN1:
          case constClass.CONFIRM: return '予約登録';
          case constClass.INPUTBIN3: return '購入数選択';
          case constClass.PAYMENT: return 'お支払い';
          case constClass.BOOKCONFIRM: return 'チケット確認';
          case constClass.FINISH: return '予約完了';
          case constClass.HISTORY: return 'ご予約履歴・変更';
          case constClass.CANCEL: return 'キャンセル';
          case constClass.RECEPT: return '受付';
          case constClass.BOOKLIST: return '利用履歴';
          case constClass.TERMS: return '利用規則';
          default: return 'メニュー';
        }
      })();

      return (
        <header className="header text-center border-bottom">
          <div className="container m-0 p-0 mw-100">
            <div className="frame146 frame145 col">
              {showBack ? (
                <div className="history-back-button">
                  <div className="text-left p-0 py-2">
                    <button className="btn w-100 py-2 d-flex" onClick={onBack}>
                      <img className="icon_back mr-1" src={icon_back} alt="ロゴ" />
                      戻る
                    </button>
                  </div>
                </div>
              ) : (
                <div className="frame147" />
              )}
              <div className="h4 mt-2 header-text">{title}</div>
              <div className="frame147" />
            </div>
          </div>
        </header>
      );
    });
  }
  setReady() {
    if (this.state.bookDateList !== null && this.state.ticketMaster !== null) {
      this.setState({ ready: true });
    } else {
      this.setState({ ready: false });
    }
  }
  async refreshData() {
    if (process.env.REACT_APP_ENV !== 'dev') {
      await window.liff.ready;
    }
    if (!this.props.liff_access_token) {
      if (!this.intervalMaster) {
        this.intervalMaster = setInterval(() => {
          this.refreshData();
        }, 500);
      }
    } else {
      clearInterval(this.intervalMaster);
      try {
        const params = { site_id: this.state.siteId, line_id: this.props.liff_access_token };
        if ((("CONTRACT_PERIOD_STARTTIME" in this.props.settings) && parseInt(this.props.settings.CONTRACT_PERIOD_STARTTIME) > parseInt(moment().format('YYYYMMDDkkmm')))) {
          this.props.history.replace(`/${this.state.siteId}/`);
        }
        const calendarPromise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/calendar/listdate/${this.state.siteId}`);
        const customerPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/search/`, params);
        const customerDetailPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/line/${this.state.siteId}`, params);
        const month = ("BOOKING_DATE_LIMIT_MONTH" in this.props.settings) ? parseInt(this.props.settings.BOOKING_DATE_LIMIT_MONTH) : 1;
        const bookDateList = (await calendarPromise).data.filter(x => moment(x.book_date).isBefore(moment().add(month, "month").subtract(1, "day")));//翌月の1日前先まで予約可能
        const customer = (await customerPromise).data;
        const customer_detail = (await customerDetailPromise).data;
        var my_customer = customer.find(c => c.line_id === this.props.liff_user_id);
        if (!my_customer) {
          // データが無ければ起動時に登録
          var data = {
            'site_id': this.state.siteId,
            'line_id': this.props.liff_access_token,
          };
          // API実行
          try {
            const result = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/line`, data)).data;
            if (result.result) {
              my_customer = result.customer;
            } else {
              alert('データの登録に失敗しました。');
            }
          } catch (err) {
            console.log(err);
            alert('エラーが発生しました。');
          }
        }


        const initialQs = this.state.initialQs ? this.state.initialQs : {
          page: this.props.page,
          book_id: this.props.bookId,
          ticket_id: this.props.ticketId,
        };

        // 利用規約に同意してないユーザは必ず利用規約画面に遷移
        if (my_customer && !my_customer.privacy_policy) {
          this.props.history.replace(`/${this.state.siteId}/?page=`);
        } else if (my_customer && my_customer.privacy_policy && !my_customer.register_date) {
          this.props.history.replace(`/${this.state.siteId}/?page=${constClass.USER}`);
        }
        if (my_customer && my_customer.privacy_policy && my_customer.register_date && (this.props.page === undefined || this.props.page === null || this.props.page === '' || this.props.page === constClass.USER)) {
          if (initialQs.page === undefined || initialQs.page === null || initialQs.page === '' || initialQs.page === constClass.USER) {
            this.props.history.replace(`/${this.state.siteId}/?page=${constClass.MENU}`);
          } else {
            var url = `/${this.state.siteId}/?page=${initialQs.page}`;
            if (initialQs.book_id) {
              url += `&bookid=${initialQs.book_id}`;
              this.props.setCurrentBook(initialQs.book_id);
            }
            if (initialQs.ticket_id) {
              url += `&ticketid=${initialQs.ticket_id}`;
              this.props.setTicketId(initialQs.ticket_id);
            }
            this.props.history.replace(url);
          }
        }
        const customer_detail_type = (await customerDetailPromise).data;

        await this.getTicketList(null);
        this.setState({
          bookDateList,
          customer_detail,
          my_customer: this.customerToState(my_customer, this.props.settings),
          customer_detail_type,
          initialQs
        });
        await this.refreshBookData();
        //決済入力画面の場合は、submitPaymentを実行
        if (this.props.page === constClass.PAYMENT && isFinite(this.props.current_bookId)) {
          this.submitPayment(this.props.current_bookId);
        }
      } catch (error) {
        console.log(error);
        this.setState({ sleeping: true });
      }
    }
    this.setReady();
  }

  async refreshBookData() {
    const book_id = isFinite(this.props.current_bookId) ? this.props.current_bookId : null;
    const book_set_id = isFinite(this.props.current_bookSetId) ? this.props.current_bookSetId : null;

    const sysdate = new Date();
    const date = moment(sysdate).format("YYYY-MM-DD");

    const params = {
      site_id: this.state.siteId,
      line_id: this.props.liff_access_token
    }
    const bookingPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/search_detail/`, params);
    const bookingDetailList = (await bookingPromise).data;

    const param = {
      site_id: this.state.siteId,
      line_id: this.props.liff_access_token,
      book_date: date,
    }

    const bookPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/search/count/`, param);
    const bookDetailList = (await bookPromise).data;

    var booking = null;
    var booking_detail = [];
    var booked = null;
    var callist = this.state.bookCalList;
    var recept = await this.getReceptdata(bookingDetailList);
    if (book_id) {
      var detail = await bookingDetailList.filter(x => (x.book_id === book_id));
      await Promise.all(detail.map(async (item) => {
        callist = await this.getCalendar(item, item, detail);
        callist.forEach((item2, idx) => {
          if (item2.start_time === item.start_time) {
            callist[idx] = { ...item2, bookok_count: item2.bookok_count + item.count }
          }
        });
        const errmsg = (item.start_time && callist.findIndex(x => x.start_time === item.start_time) < 0)
          || (item.start_time && callist.findIndex(x => x.start_time === item.start_time) >= 0 &&
            callist.find(x => x.start_time === item.start_time).bookok_count < item.count)
          ? "ご予約できない時間帯が選択されています。再選択してください" : null;
        booking_detail.push({
          ...item,
          book_date: item.book_date,
          total: CommonBooking.calcTotal(item.price, item.count),
          errcheck: errmsg,
        })
      }));
      booking = {
        ...booking_detail[0].t_booking,
        book_date: booking_detail[0].book_date,
        status: booking_detail[0].booking_status,
        booking_detail: booking_detail,
      };
      this.getTicketList(booking.book_date);
      booked = { ...booking, booking_detail: booking_detail.concat() };
    } else {
      booking = this.blankBooking();
      booking_detail = this.blankBookingDetail();
    }
    this.setState({
      book_id: book_id,
      book_set_id: book_set_id,
      set_booking: { ...booking },
      set_booking_detail: booking_detail.concat(),
      set_bookCalList: callist,
      booking: booking,
      booking_detail: booking_detail,
      bookCalList: callist,
      recept: recept,
      bookDetailList: bookDetailList,
      bookingDetailList: bookingDetailList,
      //ticketDetailList: ticketDetailList,
      booked,
      change: false,
    });
  }

  blankBooking() {
    return {
      book_id: null,
      book_date: null,
      total: 0,
      customer_id: this.state.my_customer.customer_id ? this.state.my_customer.customer_id : '',
      customer_name: this.state.my_customer.customer_name ? this.state.my_customer.customer_name : '',
      customer_kana: this.state.my_customer.customer_kana ? this.state.my_customer.customer_kana : '',
      customer_address: this.state.my_customer.customer_address ? this.state.my_customer.customer_address : '',
      gender: this.state.my_customer.gender ? this.state.my_customer.gender : '',
      birth: this.state.my_customer.birth ? this.state.my_customer.birth : '',
      postal_code: this.state.my_customer.postal_code ? this.state.my_customer.postal_code : '',
      card_no: this.state.my_customer.card_no ? this.state.my_customer.card_no : '',
      phone_number: this.state.my_customer.phone_number ? this.state.my_customer.phone_number : '',
      privacy_policy: constClass.FLAG.OFF,
      payment_fin_flag: constClass.FLAG.OFF,
      status: null,
    }
  }
  blankBookingDetail() {
    return [];
  }

  customerToState(customer, setting) {
    // 退会済みデータは画面に反映しない
    if (customer.status === constClass.STATUS.CCL) {
      return {
        ...customer,
        customer_name: '',
        customer_kana: '',
        gender: '',
        birth: '',
        phone_number: '',
        postal_code: '',
        address: '',
        card_no: '',
        mail_address: '',
        cancel_cause: '',
        privacy_policy: constClass.FLAG.OFF,
        agreement: constClass.FLAG.OFF,
        t_customer_detail: [],
      }
    } else {
      return {
        ...customer,
        customer_name: customer.customer_name ? customer.customer_name : '',
        customer_kana: customer.customer_kana ? customer.customer_kana : '',
        gender: customer.gender ? customer.gender : '',
        birth: customer.birth ? customer.birth : '',
        phone_number: customer.phone_number ? customer.phone_number : '',
        postal_code: customer.postal_code ? customer.postal_code : '',
        address: customer.address ? customer.address : '',
        card_no: customer.card_no ? customer.card_no.slice(setting['PREFIX_CARD_NO'] ? setting['PREFIX_CARD_NO'].length : 0) : '',
        mail_address: customer.mail_address ? customer.mail_address : '',
        cancel_cause: '',
        privacy_policy: customer.privacy_policy ? customer.privacy_policy : constClass.FLAG.OFF,
        agreement: customer.agreement ? customer.agreement : constClass.FLAG.OFF,
      }
    }
  }

  async getTicketList(book_date) {
    var params = {
      site_id: this.state.siteId,
      book_date: book_date ? book_date : null,
      line_id: this.props.liff_access_token
    }
    var reg_params = {
      site_id: this.state.siteId,
      line_id: this.props.liff_access_token
    }
    const ticketPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket/list/`, params);
    const ticketdetailPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket/list/search/`, reg_params);
    const ticketMaster = (await ticketPromise).data;
    const ticketdetailMaster = (await ticketdetailPromise).data;


    this.setState({ ticketMaster, ticketdetailMaster });
  }

  //予約対象のカレンダーリストを取得
  async getCalendar(book, book_detail, list = null) {
    if ((book.status && constClass.STATUS_CCL.includes(book.status))) return [];
    const params = {
      site_id: this.state.siteId,
      book_date: book.book_date,
      line_id: this.props.liff_access_token,
      ticket_id: this.props.ticketId,
    }
    this.setState({ disabled: true });
    const dataPromise = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/calendar/search/`, params);
    this.setState({ disabled: false });

    return (dataPromise.data);

  }

  async setYears(from, to) {
    const items = [];
    const nowYear = new Date().getFullYear();
    var range_from = from ? from : nowYear;
    var range_to = to ? to : nowYear;
    items.push(<option value="" key={"-"}>- 年 -</option>);
    if (range_from < range_to) {
      for (let i = range_from; i <= range_to; i++) {
        items.push(<option value={i} key={i}>{i}年</option>);
      }
    } else {
      for (let i = range_from; i >= range_to; i--) {
        items.push(<option value={i} key={i}>{i}年</option>);
      }
    }
    return items;
  }
  async setMonth(year) {
    const items = [];
    const now = new Date();
    const nowYear = now.getFullYear();
    const nowMonth = now.getMonth() + 1;
    items.push(<option value="" key={"-"}>- 月 -</option>);
    for (let i = 1; i <= 12; i++) {
      if (year < nowYear || (Number(year) === nowYear && i <= nowMonth)) {
        items.push(<option value={("00" + i).slice(-2)} key={i}>{i}月</option>);
      }
    }
    return items;
  }
  async setDay(value) {
    const items = [];
    const year = value.slice(0, 4);
    const month = value.slice(4, 6);
    const now = new Date();
    items.push(<option value="" key={"-"}>- 日 -</option>)
    for (let i = 1; i <= 31; i++) {
      const date = new Date(year + '/' + month + '/' + ("00" + i).slice(-2));
      if (!year || !Number(month) || (date.getDate() === i && date <= now)) {
        items.push(<option value={("00" + i).slice(-2)} key={i}>{i}日</option>)
      }
    }
    return items;
  }

  async handleDateChange(e, changeEvent) {
    const target = e.target;
    const type = target.id.split('-')[0];
    const seq = target.id.split('-')[1];
    var temp = Number(document.getElementById(type + '-' + seq + '-y') ? document.getElementById(type + '-' + seq + '-y').value : 0) * 10000;
    temp += Number(document.getElementById(type + '-' + seq + '-m') ? document.getElementById(type + '-' + seq + '-m').value : 0) * 100;
    temp += Number(document.getElementById(type + '-' + seq + '-d') ? document.getElementById(type + '-' + seq + '-d').value : 0);
    changeEvent({
      target: {
        type: 'text',
        name: target.name,
        value: ("00000000" + temp).slice(-8)
      }
    })
  }

  //変更対象予約情報をセット
  async submitCurrentbooking(book_id, page) {
    await this.props.setCurrentBook(book_id);
    const url = `/${this.state.siteId}/?${page ? `page=${page}` : ""}${book_id ? `&id=${book_id}` : ""}`;
    this.props.history.push(url);
    await this.refreshBookData();
  }

  getCurrentTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
  }

  componentDidMount() {
    this.refreshData();
    this.disableBounceScroll();
    this.startTimer();
  }

  componentDidUpdate(prevProps) {
    if (this.props.page !== prevProps.page) {
      this.startTimer();
    }
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  startTimer() {
    if (this.props.page === constClass.BOOKCONFIRM) {
      this.clearTimer();
      this.intervalId = setInterval(() => {
        this.setState(prevState => ({
          currentTime: this.getCurrentTime(),
          activeIndex: (prevState.activeIndex + 1) % 3,
        }));
      }, 1000);
    } else {
      this.clearTimer();
    }
    if (this.props.page === constClass.BOOKCONFIRM) {
      this.dataRefreshId = setInterval(() => {
        const today = moment().format("YYYY-MM-DD");
        const bookingDetail = this.state.bookingDetailList.find(t => t.book_id === this.props.bookId);
        if (bookingDetail && (bookingDetail.status === "FIN" || bookingDetail.status === "REG") && bookingDetail.book_date === today) {
          this.refreshData();
        }
      }, 30000);
    } else {
      this.clearTimer();
    }
  }

  clearTimer() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  disableBounceScroll() {
    let touchY = 0;

    document.body.addEventListener('touchstart', (e) => {
      touchY = e.touches[0].screenY;
    });

    document.body.addEventListener('touchmove', (e) => {
      let el = this.pageRef.current;// e.targetが機種によって変動するため、pageに固定
      const moveY = e.touches[0].screenY;
      let noScroll = true;

      while (el !== null) {
        if (el.offsetHeight < el.scrollHeight) {
          if (touchY < moveY && el.scrollTop === 0) {
            break;
          }
          if (touchY > moveY && el.scrollTop === el.scrollHeight - el.offsetHeight) {
            break;
          }
          noScroll = false;
          break;
        }
        el = el.parentElement;
      }
      if (noScroll) {
        if (e.cancelable) {
          e.preventDefault();
        }
      }

      touchY = moveY;
    }, { passive: false });
  }

  scrollPageTop() {
    setTimeout(() => {
      let el = this.pageRef.current;// e.targetが機種によって変動するため、pageに固定
      if (el) el.scrollTo(0, 0);
      else window.scrollTo(0, 0);
    }, 1);
  }

  scrollWindowTop() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  }

  changeCustomer(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    const my_customer = { ...this.state.my_customer, [name]: value };
    this.setState({
      my_customer
    });
  }

  //予約対象の取得と確認
  async setChangeBinDetail(book, book_detail) {
    var callist = this.state.bookCalList;
    var calmsg = this.state.bookCalListMessage;
    var total = 0;
    await Promise.all(book_detail.map(async (item, idx) => {
      if (this.state.category_id) {
        // 指定した日付・カテゴリのカレンダー(在庫数)を取得する
        var calendar = await this.getCalendar(book, book_detail[idx], book_detail);
        //予約可件数を計算
        calendar.forEach((item2, idx) => {
          var count = 0;
          if (this.state.booked && this.state.booked.booking_detail && this.state.booking.book_date === this.state.booked.book_date
            && this.state.booked.booking_detail.length >= 0) {
            const booked_detail = this.state.booked.booking_detail[0];
            //予約可件数に自身の予約済件数を加算
            count = (item2.start_time === booked_detail.start_time && item2.end_time === booked_detail.end_time) ? booked_detail.count : 0;
          }
          calendar[idx] = { ...item2, bookok_count: item2.bookok_count + count }
        });

        // 指定した開始時間～終了時間のカレンダー(在庫)が無い
        var errflag = false;
        if (book_detail[idx].start_time && book_detail[idx].end_time) {
          var cal_idx = calendar.findIndex(x => x.start_time === book_detail[idx].start_time && x.end_time === book_detail[idx].end_time);
          if (cal_idx >= 0 && calendar[cal_idx].bookok_count < book_detail[idx].count) {
            errflag = true;
          }
        }
        const errmsg = errflag ? "予約できない時間帯が選択されています。再選択してください。" : null;

        book_detail[idx] = {
          ...book_detail[idx],
          total: book_detail[idx].category_id ? CommonBooking.calcTotal(book_detail[idx].price, book_detail[idx].count) : 0,
          errcheck: errmsg,
        };
        total += book_detail[idx].total;
        callist = calendar;
        calmsg = calendar.length <= 0 ? "予約できる時間帯がありません" : null;
      }
    }));
    this.setState({
      booking: { ...book, total: total },
      booking_detail: book_detail,
      bookCalList: callist,
      bookCalListMessage: calmsg,
    });
  }

  /* 予約日変更 */
  async changeBookDate(val) {
    const book = { ...this.state.booking, book_date: val };
    await this.getTicketList(val);
    await this.setChangeBinDetail(book, this.state.booking_detail);
  }
  // カテゴリ変更
  async changeCategory(val, text) {
    var booking_detail = this.state.booking_detail;
    const idx = 0;
    booking_detail[idx] = {
      ...booking_detail[idx],
      category_id: null,
      book_date: null,
      start_time: null,
      end_time: null,
      price_before_tax: null,
      price: null,
      tax_rate: null,
      count: 1,
      errcheck: null,
      total: 0,

      getoff_time: null,
      fare: null,
    };

    this.setState({
      category_id: Number(val),
      category_name: text,
      booking_detail: booking_detail,
      bookCalList: null,
      bookCalListMessage: null,
    });
  }

  async searchBin() {
    var booking_detail = this.state.booking_detail;
    const idx = 0;
    booking_detail[idx] = {
      ...booking_detail[idx],
      category_id: null,
      book_date: null,
      start_time: null,
      end_time: null,
      price_before_tax: null,
      price: null,
      tax_rate: null,
      count: 1,
      errcheck: null,
      total: 0,
    };
    if (this.state.category_id) {
      await this.setChangeBinDetail(this.state.booking, booking_detail);
    } else {
    }
  }

  // 時間帯変更
  changeBookSetId(val) {
    const value = val;
    var detail = this.state.booking_detail;
    const idx = 0;
    if (value) {
      if (value.bookok_count < detail[idx].count) {
        return
      }
    }

    detail[idx] = {
      ...detail[idx],
      category_id: value && value.category_id ? value.category_id : null,
      category_name: this.state.category_name,
      book_date: value && value.book_date ? value.book_date : null,
      book_set_id: value && value.book_set_id ? value.book_set_id : null,
      start_time: value && value.start_time ? value.start_time : '',
      end_time: value && value.end_time ? value.end_time : null,
      price_before_tax: value && value.price_before_tax ? value.price_before_tax : null,
      price: value && value.price ? value.price : null,
      tax_rate: value && value.tax_rate ? value.tax_rate : null,
      count: value && value.count ? value.count : 1,
      remarks: value && value.remarks ? value.remarks : null,
      errcheck: null,
    };
    this.setChangeBinDetail(this.state.booking, detail);
  }

  changeClick(state, page) {
    this.setState(state);
    this.props.history.push(`/${this.state.siteId}/?page=${page}`);
  }

  checkInvalid() {
    const c = this.state.my_customer;
    const inputCheck = (!c.gender || !c.birth || !c.postal_code);
    return inputCheck;
  }

  // 予約便の確認 true:有効
  checkBookingValid(booking, booking_detail, bookCalList, settings = null) {
    var errchk = [];
    booking_detail.forEach(detail => {
      if (detail.category_id && detail.start_time) {
        const bookcal = bookCalList.find(x => x.category_id === detail.category_id && x.start_time === detail.start_time);
        const count = bookcal ? bookcal.bookok_count : 0;
        if (detail.count > count) errchk.push(false);
      }
    });
    if (errchk.length > 0) return false;
    return true;
  }

  //時間帯が重なる予約件数制限
  checkBookingDateCount() {
    var res = 0;
    const book_date = this.state.booking.book_date;
    const list = this.state.bookingDetailList.filter(x => !(constClass.STATUS_CCL.includes(x.booking_status)) && (!this.state.booking.book_id || x.book_id !== this.state.booking.book_id) && x.book_date === book_date);
    this.state.booking_detail.forEach(detail => {
      if (list.filter(x => x.start_time < detail.end_time && x.end_time > detail.start_time).length >= parseInt(this.props.settings.MAX_SAME_TIME)) res = 1;
    });
    return res
  }

  resetBooking(a) {

    const book = this.blankBooking();
    const detail = this.blankBookingDetail();
    this.setState({
      booking: book,
      booking_detail: detail,
      bookCalList: null,
      bookCalListMessage: null,
      set_booking: { ...book },
      set_booking_detail: detail.concat(),
      set_bookCalList: null,
      booked: null,
      change: false,
    })
  }

  resetBook() {
    const book = this.blankBooking();
    const detail = this.blankBookingDetail();
    const { selectedEntry } = this.state;
    this.setState({
      booking: book,
      booking_detail: detail,
      bookCalList: null,
      bookCalListMessage: null,
      detail_type: "1",
      entry_type: "E01",
      entry_data: this.state.ticketMaster.filter(a => a.ticket_detail_data.filter(b => b.entry_name)) === selectedEntry ? this.state.ticketMaster.ticket_detail_data.entry_data : "",
      set_booking: { ...book },
      set_booking_detail: detail.concat(),
      set_bookCalList: null,
      booked: null,
      change: false,
    })

    if (!this.state.inputCount) {
      alert('購入数が選択されていません。')
      return false;
    }

    if (this.state.inputCount > this.state.ticketMaster.filter(a => a.ticket_id === this.props.ticketId).map(t => t.user_limit)) {
      alert('購入数が上限を超えています。')
      return false;
    }

    if (
      this.state.ticketMaster
        .filter(m => m.site_id === parseInt(this.props.siteId, 10) && m.ticket_id === this.props.ticketId)
        .some(item => (this.state.bookDetailList.find(a => a.ticket_id === this.props.ticket_id) && Number(this.state.bookDetailList.find(a => a.ticket_id === this.props.ticketId).count) + Number(this.state.inputCount)) > item.booking_limit)
    ) {
      alert("これ以上予約できません。予約数を減らしてください。");
      return false;
    }

    if (this.state.bookDateList.some(b =>
      moment(b.book_date).isSame(moment(), 'day') && b.book_status === "STOP")) {
      alert("現在受付を停止しております");
      return false;
    }

    if (this.state.ticketMaster.find(m => m.site_id === parseInt(this.props.siteId) && m.ticket_id === this.props.ticketId).ticket_detail_data.filter(a => a.entry_data === '10').some(x => moment(x.entry_note, 'HH:mm', true).isBefore(moment().add(1, 'minutes')))) {
      alert("すでに受付時間を過ぎているため、このチケットは予約できません");
      return false;
    }

    if (this.state.bookingDetailList.filter(t => (t.status === "REG" || t.status === "PRE" || t.status === "FIN") && moment(t.book_date).isSame(moment(), 'day') && t.ticket_id === this.props.ticketId).length > 0) {
      alert("すでに予約しているチケットがあります");
      return false;
    }

    this.submit();
  }
  async submit() {
    // API実行
    if (!this.checkBookingValid(this.state.booking, this.state.bookingDetailList, this.state.bookCalList)) {
      alert('指定数の予約が取れません。時間帯または予約数の変更をお願いします。');
      return false;
    }
    const check_res = this.checkBookingDateCount();
    if (check_res === 1) {
      alert(`時間帯が重なるご予約はできません。`);
      return false;
    }
    try {
      const detail = this.state.selectedDetail.map((item) => ({
        site_id: this.state.siteId,
        book_id: item.book_id ? item.book_id : null,
        detail_type: constClass.DETAIL_TYPE.TICKET,
        entry_type: item.entry_type,
        entry_data: item.entry_data,
      })
      );
      var data = {
        site_id: this.state.siteId,
        book_id: this.state.booking.book_id ? this.state.booking.book_id : null,
        book_date: moment().format("YYYYMMDD"),
        ticket_id: this.props.ticketId,
        count: this.state.inputCount,
        customer_id: this.state.my_customer.customer_id,
        receipt_num: (this.state.booking.book_id) ? this.state.booking.receipt_num : null,
        receipt_datetime: (this.state.booking.book_id) ? new Date(this.state.booking.receipt_datetime) : new Date(),
        customer_name: this.state.booking.customer_name,
        customer_kana: this.state.booking.customer_kana,
        customer_address: this.state.booking.customer_address,
        gender: this.state.my_customer.gender,
        birth: this.state.my_customer.birth,
        postal_code: this.state.my_customer.postal_code,
        card_no: this.state.my_customer.card_no,
        phone_number: this.state.booking.phone_number,
        privacy_policy: this.state.my_customer.privacy_policy,
        line_id: this.props.liff_access_token,
        subtotal: this.state.ticketMaster.find(x => x.ticket_id === this.props.ticketId).amount,
        discount: 0, tax: 0,
        total: CommonBooking.calcTotal(this.state.bookDateList.map(t => t.price), this.state.inputCount),
        price: this.state.bookDateList.filter(a => a.book_date === moment(new Date()).format("YYYY-MM-DD")).map(b => b.price),
        before_total: (this.state.booked && this.state.booked.total) ? this.state.booked.total : null,
        payment_fin_flag: (this.state.booking.book_id) ? this.state.booking.payment_fin_flag : constClass.FLAG.OFF,
        status: (this.state.booking.book_id) ? this.state.booking.status : constClass.STATUS.UPAY, //初期ステータスは未決済
        t_booking_detail: detail,
        before_booking_detail: (this.state.booking.book_id) ? this.state.booked.booking_detail : [],
      }

      this.setState({ disabled: true });
      var result = null;
      if (this.state.booking.book_id) {
        result = (await axios.put(`${process.env.REACT_APP_BACKEND_URL}/booking/${data.book_id}`, data));
      } else {
        result = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/`, data));
      }
      this.setState({ disabled: false });
      if (result.data && result.data.result) {
        const book_id = result.data && result.data.result && result.data.book && result.data.book.book_id ? result.data.book.book_id : data.book_id;
        if (book_id && result.data.book && result.data.book.status === constClass.STATUS.UPAY) {
          this.props.setCurrentBook(book_id);
          await this.refreshBookData();
          await this.submitPayment(book_id);
        } else {
          this.submitCurrentbooking(null, constClass.MENU);
        }
      } else {
        //err
        console.log(util.inspect(result))
        alert('登録に失敗しました。1');
      }
    } catch (e) {
      var errMsg = "";
      if (e.fileName && e.lineNumber) {
        // ファイル名と行番号が取得できたらメッセージとしてログに出力する
        errMsg = "ファイル名：" + e.fileName + "、 行番号：" + e.lineNumber;
      } else {
        errMsg = e.message;
      }
      //例外エラーがおきたら、コンソールにログを出力する
      console.error("エラー：", errMsg);
      var message = (e.response && e.response.data && e.response.data.message) ? e.response.data.message : '登録に失敗しました。';
      alert(message);
    } finally {
      this.setState({ disabled: false });
    }
    return false;
  }

  handleInputChange = (e) => {
    this.setState({ inputCount: e.target.value });
  };

  handleEntryChange = (e) => {
    this.setState({ selectedEntry: e.target.value });
  };

  handleExitChange = (e) => {
    this.setState({ selectedExit: e.target.value });
  };

  handleDetailChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    const detail = [...this.state.selectedDetail];
    Common.setCustomerDetail(detail, name, value);
    this.setState({
      selectedDetail: detail
    });
  }

  handleIncrement() {
    const limit = this.state.ticketMaster.find(x => x.ticket_id === this.props.ticketId && x.site_id === parseInt(this.props.siteId))?.user_limit || 0;
    this.setState(prevState => {
      if (prevState.inputCount < limit) {
        return { inputCount: prevState.inputCount + 1 };
      }
      return null;
    });
  }

  handleDecrement() {
    this.setState(prevState => {
      if (prevState.inputCount > 1) {
        return { inputCount: prevState.inputCount - 1 };
      }
      return null;
    });
  }

  changeCustomerDetail(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    const detail = [...this.state.my_customer.t_customer_detail];
    Common.setCustomerDetail(detail, name, value);
    const my_customer = { ...this.state.my_customer, t_customer_detail: detail };
    this.setState({
      my_customer
    });
  }

  async submitPayment(book_id) {
    this.setState({ disabled: true });
    const params = {
      Overview: this.props.settings.TITLE_SHORT_NAME,
    };
    const payment_data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/payment/${this.props.siteId}/${book_id}`, params)).data;
    // urlがある⇒画面遷移
    if (payment_data.url) {
      const form = document.createElement('form');
      form.action = payment_data.url;
      form.method = payment_data.method;

      // body に追加
      document.body.append(form);
      for (const i in payment_data.data) {
        // obj.hasOwnProperty() はオブジェクトのプロトタイプチェーンからプロパティを絞り込むために使用しています
        if (payment_data.data.hasOwnProperty(i)) {
          const input = document.createElement('input');
          input.setAttribute('type', 'hidden');
          input.setAttribute('name', i);
          input.setAttribute('value', payment_data.data[i]);
          form.appendChild(input);
        }
      }

      // submit
      form.submit();
    } else {
      // urlが無い⇒paymentモジュール画面へ遷移
      this.setState({ payment_data: payment_data.data, disabled: false });
      console.log(payment_data);

      this.props.history.push(`/${this.state.siteId}/?page=${constClass.PAYMENT}&id=${book_id}`);
    }
  }
  async backPayment() {
    console.log("backPayment")
    await this.refreshBookData();
  }
  async returnPayment() {
    console.log("returnPayment")
    await this.refreshBookData();
  }

  async customerSubmit() {
    if (this.checkInvalid() || this.state.disabled) {
      return;
    }
    this.setState({ disabled: true });

    // customerデータ準備    
    var data = {
      'site_id': this.state.siteId,
      'line_id': this.props.liff_access_token,
      'gender': this.state.my_customer.gender,
      'birth': this.state.my_customer.birth,
      'postal_code': this.state.my_customer.postal_code,
      'card_no': this.state.my_customer.card_no ? this.props.settings['PREFIX_CARD_NO'] + this.state.my_customer.card_no : '',
      'privacy_policy': this.state.my_customer.privacy_policy,
      'register_date': this.props.page === constClass.USERCONFIRMATION ? this.state.my_customer.register_date : new Date(),
      't_customer_detail': this.state.my_customer.t_customer_detail,
    };

    // API実行
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/line/insert/${this.state.my_customer.customer_id}`, data);
      if (this.props.page === constClass.USERCONFIRMATION) {
        alert('変更が完了しました。');
        await this.refreshData();
      } else {
        await this.refreshData();
      }
      this.setState({
        disabled: false,
        message: {
          mail_address: '',
          gender: '',
          birth: '',
          postal_code: '',
          card_no: '',
          phone_number: '',
        },
        user_change: false,
      });
    } catch (err) {
      console.log(util.inspect(err));
      if (err.response && err.response.data) {
        alert(err.response.data);
      } else {
        alert('エラーが発生しました。');
      }
      this.setState({ disabled: false });
    }
  }

  async submitTerms() {
    var data = {
      'site_id': this.state.siteId,
      'line_id': this.props.liff_access_token,
      'gender': this.state.my_customer.gender,
      'birth': this.state.my_customer.birth,
      'postal_code': this.state.my_customer.postal_code,
      'card_no': this.state.my_customer.card_no ? this.state.settings['PREFIX_CARD_NO'] + this.state.my_customer.card_no : '',
      'privacy_policy': constClass.FLAG.ON,
      't_customer_detail': this.state.my_customer.t_customer_detail ? this.state.my_customer.t_customer_detail : [],
      'privacy_attention': 0,
    };
    // API実行
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/line/insert/${this.state.my_customer.customer_id}`, data);
      await this.refreshData();
      if (!this.state.my_customer.register_date) {
        this.props.history.push(`/${this.state.siteId}/?page=${constClass.USER}`);
      }
    } catch (err) {
      // alert('エラーが発生しました。');
      console.log(err);
    }
  }

  renderBottom() {
    const titlename = () => {
      switch (this.props.page) {
        case constClass.BINSELECT: return (
          <div className="text-center text-bottom">
            <img src={`/${this.props.siteId}/icon.svg`} alt="ロゴ" />
            <div>ご予約のキャンセルには<br />キャンセル料100円をいただきます。</div>
          </div>)
        case constClass.BOOKCONFIRM: {
          if (this.state.bookingDetailList.some(a =>
            a.book_id === this.props.bookId && (a.status === "REG" || a.status === "PRE")
          )) {
            return (
              <div className="text-center text-bottom">
                <img src={`/${this.props.siteId}/icon.svg`} alt="ロゴ" />
                <div>ご予約のキャンセルには<br />キャンセル料100円をいただきます。</div>
              </div>
            );
          } else if (this.state.bookingDetailList.some(a =>
            a.book_id === this.props.bookId && a.status === 'OVER'
          )) {
            return (
              <div className="text-center text-bottom">
                <img src={`/${this.props.siteId}/icon.svg`} alt="ロゴ" />
                <div>乗車時間が過ぎた予約の<br />キャンセルはできません</div>
              </div>
            );
          } else {
            return "";
          }
        }
        case constClass.BOOKLIST: return (<div className='text-center mt-5'>
          <img src={`/${this.props.siteId}/icon.svg`} alt="ロゴ" />
          <div>未乗車・乗車中の予約は表示されません</div>
        </div>)
        case constClass.USER:
          return (
            <div className='mx-3'>
              {
                <div className="frame61">
                  <button
                    className="button text-black bg-lightwhite"
                    onClick={() => { this.customerSubmit() }}>
                    登録
                  </button>
                </div>
              }
            </div>
          )
        case constClass.USERCONFIRMATION:
          return (<div className='mx-3'>
            {
              <div className="frame61">
                <button
                  className="button text-black bg-lightwhite"
                  onClick={() => { this.customerSubmit() }}>
                  変更
                </button>
              </div>
            }</div>)
        default:
      }
    }
    return (
      <footer className="footer">
        <div className="row mx-0">
          <div className={`col bottom text-center mb-3 mt-1`}>
            {titlename(this)}
          </div>
        </div>
      </footer>
    );
  }


  async getReceptdata(bookingDetailList) {
    const nowDate = moment().format('YYYYMMDD');
    const nowTime = moment().format('HHmmss');
    var recept = null;
    var list = [];
    await Promise.all(bookingDetailList.map(async item => {
      if (moment(item.book_date).format('YYYYMMDD') === nowDate && nowTime <= item.end_time && (!recept || recept.start_time > item.start_time) &&
        constClass.STATUS.FIN === item.booking_status) {
        recept = item;
      } else {
        if (constClass.STATUS_RECEPTOK.includes(item.booking_status) && moment(item.book_date).format('YYYYMMDD') === nowDate && nowTime <= item.end_time) {
          list.push(item);
        }
      } list.push(item);
    }));

    if (recept !== null) return recept;
    if (list.length > 0) {
      return list;
    }
    return list[0];
  }

  renderReceptButton() {
    return (
      <div className="mx-0 mt-3 mb-3 text-center">
        <div className='usehistory-btn'>
          <div className="col px-0">
            <Link to={`/${this.state.siteId}/?page=${constClass.BOOKLIST}`}>
              <button
                className={`btn w-100 h-100 py-3 px-2`}>
                <div className=''>
                  {/* <div className='col-2 m-0 p-0 pl-2 text-left align-self-center'><img src={ReceptImg} style={{ width: "40px" }} alt={"受付"} /></div> */}
                  <div className='col m-0 p-0 text-center align-self-center font-color-lightglay'><span className="mb-0 payment-attention">利用履歴</span></div>
                </div>
              </button>
            </Link>
          </div>
        </div>
      </div>
    )
  }

  renderMenu() {
    return (
      <div className="row mx-0">
        <div className="col px-0">
          <div>
            <div className="frame1">
              <img className='w-100' src={`/${this.props.siteId}/logo.png`} alt="ロゴ" />
            </div>
            <div className="bookmenu">
              <div className="menu-text pt-4">
                <span className='textcolor font-weight-bold payment-attention'>本日の予約済みチケット</span>
              </div>
              <div className="col py-1 px-1 align-self-center">
                <div className="frame17">
                  {this.state.bookingDetailList.filter(t => t.status !== "CCL" && t.status !== "UPAY" && t.status !== "CUPAY" && moment(t.book_date).isSame(moment(), 'day')).length > 0 ?
                    (this.state.bookingDetailList.filter(t => t.status !== "CCL" && t.status !== "UPAY" && t.status !== "CUPAY" && moment(t.book_date).isSame(moment(), 'day')).map((item, idx) => (
                      <Link key={idx} to={item.status === "FIN" ? `/${this.state.siteId}/?page=${constClass.BOOKCONFIRM}&bookid=${item.book_id}` : `/${this.state.siteId}/?page=${constClass.BOOKCONFIRM}&bookid=${item.book_id}`} className="no-hover">
                        <div className="reserveticketbotton mb-3">
                          <div className='m-0 p-0 align-items-center'>
                            <div className="row m-0 p-0">
                              <div className='frame3'>
                                <div className="h4 d-flex justify-content-between textcolor font-weight-bold pt-3 ml-4">
                                  <div className="h4 font-weight-bold text-left textcolor mb-0">{item.t_booking_ticket?.ticket_name}</div>
                                  <span className='mr-4 mt-auto'><img className="align-center mr-2" src={icon_count} alt="人数" />{item.count}</span>
                                </div>
                                <div className="row ml-4">
                                  <span className='row ml-1'>
                                    <div className="">
                                    </div>
                                    <div>
                                      {item.t_booking_detail?.map(bd => (
                                        <React.Fragment key={bd.entry_type}>
                                          <div key={`${bd.entry_type}`}>
                                            <div className="text-primary font-weight-bold">
                                              {this.state.ticketdetailMaster?.find(t => t.entry_type === bd.entry_type)?.ticket_detail_data_type?.entry_type_name}:
                                              {this.state.ticketdetailMaster?.find(t => t.entry_type === bd.entry_type)?.entry_name}
                                            </div>
                                          </div>
                                        </React.Fragment>
                                      ))}
                                    </div>
                                  </span>
                                </div>
                              </div>
                              <div className="ticketconfirm-btn">
                                <button
                                  onClick={() => { this.resetBooking(); this.props.setBookId(item.book_id); }}
                                  className={`btn custom-button h-100`}>
                                  <div className="text-white">＞<br />チケット<br />確認</div>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    ))) :
                    <div className="menu-border row align-items-center m-0">
                      <div className="ml-4 d-flex h5 frame18 py-5">チケットがありません</div>
                    </div>
                  }
                </div>
                <div className="book-menu-botton">
                  <div className="row mx-0 mt-3 text-center">
                    <div className="col px-0">
                      <div className={this.state.bookingDetailList.filter(t => moment(t.book_date).isSame(moment(), 'day')).some(a => a.status === "REG" || a.status === "FIN") ? "customerinformation-btn" : "newreserve"}>
                        <Link to={`/${this.state.siteId}/?page=${constClass.BINSELECT}`}>
                          <button
                            onClick={e => this.resetBooking()}
                            disabled={this.state.bookingDetailList.filter(t => moment(t.book_date).isSame(moment(), 'day')).some(a => a.status === "REG" || a.status === "FIN")}
                            className={`btn btn-booking w-100 h-100 py-3 px-2`}>
                            <div className='row m-0 p-0'>
                              <div className='col-12 m-0 p-0 text-center align-self-center'><span className={this.state.bookingDetailList.filter(t => moment(t.book_date).isSame(moment(), 'day')).some(a => a.status === "REG" || a.status === "FIN") ? "mb-0 payment-attention" : "mb-0 menu-fontcolor payment-attention"}>
                                {this.state.bookingDetailList.filter(t => moment(t.book_date).isSame(moment(), 'day')).some(a => a.status === "REG" || a.status === "FIN") ? "予約済" : "新規予約"}</span>
                              </div>
                            </div>
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="row m-0">
                    <div className="col-6 px-1 align-self-center">
                      {this.renderReceptButton()}
                    </div>
                    <div className="col-6 px-1 align-self-center">
                      <div className='customerinformation-btn'>
                        <Link to={`/${this.state.siteId}/?page=${constClass.USERCONFIRMATION}`}>
                          <button
                            className={`btn w-100 h-100 py-3 px-2`}>
                            <span className="mb-0 font-color-lightglay payment-attention">お客様情報</span>
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                  {Common.getSettingValue(this.props.settings, 'MENU_NOTICE') &&
                    <div className="row m-0">
                      <div className="col px-1">
                        <div className="mt-1"><span className="small">{Common.getSettingValue(this.props.settings, 'MENU_NOTICE')}</span></div>
                      </div>
                    </div>
                  }

                </div>
                <div className="frame95 mt-5">
                  <div className="menu-terms d-flex justify-content-center my-5">
                    <div className='link-blue' onClick={() => { this.props.history.push(`/${this.state.siteId}/?page=${constClass.TERMS}`); this.scrollPageTop(); }}>
                      <u className='payment-attention'>利用規則</u>
                    </div>
                  </div>
                  {Common.getSettingValue(this.props.settings, 'ATTENTION_URL') &&
                    <div className=" d-flex justify-content-center">
                      <a href={Common.getExternalUrl(Common.getSettingValue(this.props.settings, 'ATTENTION_URL'))} target="_blank" rel="noreferrer">
                        <u className="menu-terms payment-attention">特定商取引法について</u>
                      </a>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderUser(change) {
    const renderInput = (setting, name, type, suffix) => {
      const large_name = String(name).toUpperCase();
      const entry_type = {
        entry_type: name,
        required: setting['INPUT_' + large_name] === constClass.INPUT.REQUIRED ? 1 : 0,
        entry_type_name: setting['LABEL_' + large_name],
        detail_data: [],
        notice: setting['NOTICE_' + large_name],
        info: setting['INFO_' + large_name],
      }
      if (name === 'gender') {
        entry_type.detail_data = [
          { input_type: 'radio', entry_type: name, entry_seq: 1, entry_name: constClass.GENDER_NAME.MAN, entry_data: constClass.GENDER.MAN, param_name: name },
          { input_type: 'radio', entry_type: name, entry_seq: 2, entry_name: constClass.GENDER_NAME.WOMAN, entry_data: constClass.GENDER.WOMAN, param_name: name },
          { input_type: 'radio', entry_type: name, entry_seq: 3, entry_name: constClass.GENDER_NAME.OTHER, entry_data: constClass.GENDER.OTHER, param_name: name },
        ]
      } else if (name === 'birth') {
        entry_type.detail_data = [
          { input_type: type, entry_type: name, entry_seq: 1, param_name: name, range_to: '1900', use_year: setting['INPUT_BIRTH_YEAR'], use_month: setting['INPUT_BIRTH_MONTH'], use_date: setting['INPUT_BIRTH_DATE'] },
        ]
      } else {
        entry_type.detail_data = [
          { input_type: type, entry_type: name, entry_seq: 1, param_name: name, placeholder: setting['PLACEHOLDER_' + large_name], prefix: setting['PREFIX_' + large_name], max_length: name === 'postal_code' ? 7 : name === 'phone_number' ? 14 : name === 'card_no' ? 15 : null },
        ]
      }
      return [constClass.CUSTOMER_INPUT.ENABLED, constClass.CUSTOMER_INPUT.REQUIRED].includes(setting['INPUT_' + large_name]) ? renderInputDetail(entry_type, this.state.my_customer, this.changeCustomer, suffix) : null;
    }

    const renderInputDetail = (entry_type, values, changeHandler, suffix) => {

      const setYears = (from, to) => {
        const items = [];
        const nowYear = new Date().getFullYear();
        var range_from = from ? from : nowYear;
        var range_to = to ? to : nowYear;
        items.push(<option value="" key={"-"}>年</option>);
        if (range_from < range_to) {
          for (let i = range_from; i <= range_to; i++) {
            items.push(<option value={i} key={i}>{i}年</option>);
          }
        } else {
          for (let i = range_from; i >= range_to; i--) {
            items.push(<option value={i} key={i}>{i}年</option>);
          }
        }
        return items;
      }
      const setMonth = () => {
        const items = [];
        items.push(<option value="" key={"-"}>月</option>)
        for (let i = 1; i <= 12; i++) {
          items.push(<option value={("00" + i).slice(-2)} key={i}>{i}月</option>)
        }
        return items;
      }
      const setDay = (value) => {
        const items = [];
        const year = value.slice(0, 4);
        const month = value.slice(4, 6);
        items.push(<option value="" key={"-"}>日</option>)
        for (let i = 1; i <= 31; i++) {
          if (!year || !Number(month) || (new Date(year + '/' + month + '/' + ("00" + i).slice(-2)).getDate() === i)) {
            items.push(<option value={("00" + i).slice(-2)} key={i}>{i}日</option>)
          }
        }
        return items;
      }
      const handleDateChange = (e, changeEvent) => {
        const target = e.target;
        const type = target.id.split('-')[0];
        const seq = target.id.split('-')[1];
        var temp = Number(document.getElementById(type + '-' + seq + '-y') ? document.getElementById(type + '-' + seq + '-y').value : 0) * 10000;
        temp += Number(document.getElementById(type + '-' + seq + '-m') ? document.getElementById(type + '-' + seq + '-m').value : 0) * 100;
        temp += Number(document.getElementById(type + '-' + seq + '-d') ? document.getElementById(type + '-' + seq + '-d').value : 0);
        changeEvent({
          target: {
            type: 'text',
            name: target.name,
            value: ("00000000" + temp).slice(-8)
          }
        })
      }
      if (entry_type.entry_type === 'E01') {
        return (
          <div className={`${entry_type.entry_type}-select`} key='E01'>
            <select
              className="frame35"
              id={entry_type.entry_type + '-' + entry_type.entry_seq}
              name={entry_type.entry_type}
              onChange={changeHandler}
              onBlur={this.scrollWindowTop}
              value={values[entry_type.entry_type] || ''}
            >
              <option value="">選択してください</option>
              {entry_type.detail_data.map(t => (
                <option value={t.entry_data} key={t.entry_name}>{t.entry_name}</option>
              ))}
            </select>
          </div>
        );
      }
      if (entry_type.entry_type !== 'E01') {
        return (
          <React.Fragment key={entry_type.entry_type}>
            {entry_type.detail_data.map(d =>
              <React.Fragment key={d.entry_type + '-' + d.entry_seq}>
                {d.input_type === 'radio' && <React.Fragment>
                  <div className={`frame27 ${d.entry_type + '-' + d.entry_seq}`} key={d.entry_type + '-' + d.entry_seq}>
                    <div className="customer-option text-nowrap">
                      <div className="px-1 mx-0 align-self-center">
                        <label className="my-0" htmlFor={d.entry_type + '-' + d.entry_seq}>{d.entry_name}</label>
                      </div>
                      <div className="px-0 mx-0 align-self-center">
                        <input type="radio" className="form-control mx-1 radio-btn" id={d.entry_type + '-' + d.entry_seq} name={d.entry_type} onChange={changeHandler} value={d.entry_data} checked={values[d.entry_type] === d.entry_data} />
                      </div>
                    </div>
                  </div>
                </React.Fragment>}
                {d.input_type === 'date' && <React.Fragment>
                  <div className={`${d.entry_type + '-' + d.entry_seq}`} key={d.entry_type + '-' + d.entry_seq}>
                    <div className="frame56 mt-3 d-flex justify-content-between">
                      {d.use_year === constClass.FLAG.ON &&
                        <select className="frame27 text-center" id={d.entry_type + '-' + d.entry_seq + '-y'} name={d.entry_type} onChange={(e) => handleDateChange(e, changeHandler)} value={values[d.entry_type].slice(0, 4)}>
                          {setYears(d.range_from, d.range_to)}
                        </select>
                      }
                      {d.use_month === constClass.FLAG.ON &&
                        <select className="frame27 text-center" id={d.entry_type + '-' + d.entry_seq + '-m'} name={d.entry_type} onChange={(e) => handleDateChange(e, changeHandler)} value={values[d.entry_type].slice(4, 6)}>
                          {setMonth()}
                        </select>
                      }
                      {d.use_date === constClass.FLAG.ON &&
                        <select className="frame27 text-center" id={d.entry_type + '-' + d.entry_seq + '-d'} name={d.entry_type} onChange={(e) => handleDateChange(e, changeHandler)} value={values[d.entry_type].slice(6, 8)}>
                          {setDay(values[d.entry_type])}
                        </select>
                      }
                    </div>
                  </div>
                </React.Fragment>}
                {d.input_type === 'checkbox' && <React.Fragment>
                  <div className={`col px-0 align-self-center ${d.entry_type + '-' + d.entry_seq}`} key={d.entry_type + '-' + d.entry_seq}>
                    <div className="row px-0 mx-0">
                      <div className="col-2">
                        <input type="checkbox" className="form-control" id={d.entry_type + '-' + d.entry_seq} name={d.entry_type} value="true" checked={values[d.entry_type] === constClass.FLAG.ON} onChange={changeHandler}></input>
                      </div>
                      <div className="col-10">
                        <label className="my-0" htmlFor={d.entry_type + '-' + d.entry_seq}>{d.entry_name}</label>
                      </div>
                    </div>
                  </div>
                </React.Fragment>}
                {['text', 'number'].includes(d.input_type) && d.entry_type === 'postal_code' && <React.Fragment>
                  <input
                    type={d.input_type}
                    className={`frame35 ${d.entry_type + '-' + d.entry_seq}`}
                    id={d.entry_type + '-' + d.entry_seq}
                    name={d.entry_type}
                    value={values[d.entry_type] ? '〒' + values[d.entry_type].replace('〒', '') : '〒'}
                    onChange={(e) => {
                      const inputValue = e.target.value.replace('〒', '');
                      changeHandler({
                        target: {
                          name: d.entry_type,
                          value: inputValue
                        }
                      });
                    }}
                    maxLength={d.max_length ? d.max_length + 1 : undefined}
                    style={{ imeMode: 'disabled' }}
                  />
                  {suffix && <div className={`col-auto px-0 align-self-center ${d.entry_type + '-' + d.entry_seq + '-suffix'}`}><span>{suffix}</span></div>}
                </React.Fragment>}
                {['text', 'number'].includes(d.input_type) && d.entry_type === 'card_no' && <React.Fragment>
                  <input
                    type={d.input_type}
                    className={`frame35 ${d.entry_type + '-' + d.entry_seq}`}
                    id={d.entry_type + '-' + d.entry_seq}
                    name={d.entry_type}
                    value={values[d.entry_type] ? 'NR' + values[d.entry_type] : ''}
                    onChange={(e) => {
                      const inputValue = e.target.value.replace('NR', '');
                      changeHandler({
                        target: {
                          name: d.entry_type,
                          value: inputValue
                        }
                      });
                    }}
                    placeholder='NR'
                    maxLength={d.max_length ? d.max_length + 2 : undefined}
                    style={{ imeMode: 'disabled' }}
                  />
                  {suffix && <div className={`col-auto px-0 align-self-center ${d.entry_type + '-' + d.entry_seq + '-suffix'}`}><span>{suffix}</span></div>}
                </React.Fragment>}
              </React.Fragment>
            )}
          </React.Fragment>
        );
      }
    }
    return (
      <div id="user">
        <div className="frame62 mt-4">
          <div className="frame60">
            <div className="customer-text">
              性別
            </div>
            <div className="frame56 mt-3 d-flex justify-content-between">
              {renderInput(this.props.settings, 'gender', 'radio')}
            </div>
            <div className="customer-text mt-3 mb-2">
              生年月日（西暦）
            </div>
            {renderInput(this.props.settings, 'birth', 'date')}
            <div className="customer-text mt-3 mb-2">
              郵便番号
            </div>
            {renderInput(this.props.settings, 'postal_code', 'text')}
            {/* <div className="customer-text mt-3 mb-2">
              最寄り駅
            </div>
            {this.state.customer_detail_type.map(t => renderInputDetail(t, Common.getCustomerDetailObject(this.state.my_customer.t_customer_detail), this.changeCustomerDetail))} */}
            {/* <div className="customer-text mt-3 mb-2">
              nimoca番号（任意入力）
            </div>
            {renderInput(this.props.settings, 'card_no', 'text')} */}
          </div>
        </div>
      </div>
    );
  }

  renderBinSelect() {
    return (
      <div className="row mx-3 my-3 px-0-env">
        <div className="col">
          <div id="binselect">
            <div>
              <div className="col px-0 py-3">
                {this.state.bookDateList.filter(m => m.book_date === moment(new Date()).format("YYYY-MM-DD")).length > 0 ? (<div>
                  {this.state.ticketMaster.filter(m => m.site_id === parseInt(this.props.siteId)).map((item, idx) => (
                    <div key={idx} className='my-2'>
                      <div className={`frame3 bg-white ${this.state.bookingDetailList.filter(a => a.ticket_id === item.ticket_id && a.status !== 'CCL' && a.status !== 'UPAY' && a.status !== "CUPAY" && moment(a.book_date).isSame(moment(), 'day'))
                        .reduce((total, booking) => total + booking.count, 0) < item.booking_limit && !this.state.bookDateList.find(b => moment(b.book_date).isSame(moment(), 'day') && b.book_status === "STOP") &&
                        this.state.bookingDetailList.filter(t => (t.status === "REG" || t.status === "PRE" || t.status === "FIN") && moment(t.book_date).isSame(moment(), 'day')).length === 0 ? 'border-class' : ''}`}>
                        <div className="d-flex frame4">
                          <div className='col-9 row m-0 p-0'>
                            <div className='col-12 m-0 p-0 text-center align-self-center p-3'>
                              <span className="mb-0">
                                <div className="h4 font-weight-bold text-left textcolor">{item.ticket_name}</div>
                                <div className="text-left">{Common.getBrString(item.ticket_detail)}</div>
                                {/* <div className="row m-0 p-0">
                                  <div className="frame15">
                                    {this.state.ticketdetailMaster
                                      .filter(t => t.entry_type === "E01" && t.ticket_id === item.ticket_id && t.site_id === item.site_id)
                                      .map((item, index) => (
                                        <React.Fragment key={index}>
                                          <div className="small">〇</div>
                                          <div>｜</div>
                                        </React.Fragment>
                                      ))}
                                  </div>
                                  <div className='text-left'>
                                    {this.state.ticketdetailMaster
                                      .filter(t => t.entry_type === "E01" && t.ticket_id === item.ticket_id && t.site_id === item.site_id)
                                      .sort((a, b) => parseInt(a.entry_data) - parseInt(b.entry_data))
                                      .map(s => (
                                        <div key={`E01-${s.entry_data}`}>
                                          <div>{s.entry_name}</div>
                                          <div>{s.entry_note}</div>
                                        </div>
                                      ))}
                                  </div>
                                </div> */}
                              </span>
                            </div>
                          </div>
                          <Link className="" to={`/${this.state.siteId}/?page=${constClass.INPUTBIN3}&ticketid=${item.ticket_id}`}>
                            <div className="ticketbooking-btn">
                              <button
                                disabled={(this.state.bookDetailList.find(a => a.ticket_id === item.ticket_id) && this.state.bookDetailList.find(a => a.ticket_id === item.ticket_id).count >= item.booking_limit) || this.state.bookDateList.find(b => moment(b.book_date).isSame(moment(), 'day') && b.book_status === "STOP") || this.state.ticketMaster.find(m => m.site_id === parseInt(this.props.siteId) && m.ticket_id === item.ticket_id).ticket_detail_data.filter(a => a.entry_data === '10').some(x => moment(x.entry_note, 'HH:mm', true).isBefore(moment().add(1, 'minutes'))) ||
                                  this.state.bookingDetailList.filter(t => (t.status === "REG" || t.status === "PRE" || t.status === "FIN") && moment(t.book_date).isSame(moment(), 'day')).length > 0}
                                onClick={() => { this.resetBooking(item.ticket_id); this.props.setTicketId(item.ticket_id); }}
                                className={`btn h-100 w-100`}>
                                <div className="text-center">{
                                  (this.state.bookDetailList.find(a => a.ticket_id === item.ticket_id) && this.state.bookDetailList.find(a => a.ticket_id === item.ticket_id).count >= item.booking_limit) || (this.state.bookDateList.find(b => moment(b.book_date).isSame(moment(), 'day') && b.book_status === "STOP")) || this.state.ticketMaster.find(m => m.site_id === parseInt(this.props.siteId) && m.ticket_id === item.ticket_id).ticket_detail_data.filter(a => a.entry_data === '10').some(x => moment(x.entry_note, 'HH:mm', true).isBefore(moment().add(1, 'minutes')))
                                    || this.state.bookingDetailList.filter(t => (t.status === "REG" || t.status === "PRE" || t.status === "FIN") && moment(t.book_date).isSame(moment(), 'day')).length > 0
                                    ? <span className='text-danger'>×</span> : <span className='textcolor'>＞</span>}
                                  <br />
                                  {
                                    this.state.bookDetailList.find(a => a.ticket_id === item.ticket_id) && this.state.bookDetailList.find(a => a.ticket_id === item.ticket_id).count >= item.booking_limit ? <span className='text-danger'>満席</span> : (this.state.bookDateList.find(b => moment(b.book_date).isSame(moment(), 'day') && b.book_status === "STOP")) ||
                                      this.state.ticketMaster.find(m => m.site_id === parseInt(this.props.siteId) && m.ticket_id === item.ticket_id).ticket_detail_data.filter(a => a.entry_data === '10').some(x => moment(x.entry_note, 'HH:mm', true).isBefore(moment().add(1, 'minutes'))) ?
                                      <span className='text-danger'>受付<br />停止中</span> :
                                      this.state.bookingDetailList.filter(t => (t.status === "REG" || t.status === "PRE" || t.status === "FIN") && moment(t.book_date).isSame(moment(), 'day')).length > 0
                                        ? <span className='text-danger'>予約済</span> : <span className='textcolor'>予約へ</span>}
                                </div>
                              </button>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>) : (<div className='text-center'><img src={`/${this.props.siteId}/icon_caution.svg`} alt="ロゴ" />
                  <div className='text-center text-danger mt-2'>予約可能なチケットがありません</div></div>)}
              </div>
            </div>
            {/* <div className="col mt-3 px-1 d-flex justify-content-center">
              <a href={Common.getExternalUrl(this.props.settings.STOPTIME_URL)} target="_blank" rel="noreferrer">
                <u className="menu-terms-binselect">各駅の停車時刻をみる</u>
              </a>
            </div> */}
            {Common.getSettingValue(this.props.settings, 'TICKET_NOTICE') &&
              <div className="col mt-3 px-1 d-flex justify-content-center">
                <div className="mt-1"><span className="small">{Common.getSettingValue(this.props.settings, 'TICKET_NOTICE')}</span></div>
              </div>
            }
          </div>
          {/* {this.state.my_customer.privacy_attention !== "1" && (
            <div>
              <BookAttentionModal
                isOpen={this.state.attentionmodalflag}
                message={`<div className="text-white"><img src="/${this.props.siteId}/icon4.svg" alt="ロゴ" /><br />チケットを使用しますか？<br />ご使用後はキャンセルができなくなります</div>`}
                onConfirm={async (e) => this.attentioncloseModal()}
                disabled={false}
                siteId={this.state.modalData.siteId}
              />
            </div>)} */}
        </div>
      </div >
    );
  }

  renderInputBin3() {
    return (
      <div className="row mx-3 my-3 px-0-env">
        <div className="col">
          <div id="inputbin3">
            {this.state.ticketMaster.filter(x => x.ticket_id === this.props.ticketId && x.site_id === parseInt(this.props.siteId)).map(t =>
              <div key={t.site_id}>
                <div className="text-danger text-center">
                  {this.state.bookDetailList.find(a => a.ticket_id === t.ticket_id) && (Number(this.state.bookDetailList.find(a => a.ticket_id === t.ticket_id).count) + Number(this.state.inputCount)) > t.booking_limit ? <div className="text-center text-bottom">
                    <img src={`/${this.props.siteId}/icon_caution.svg`} alt="ロゴ" />
                    <div>予約可能な数を超えています</div>
                  </div> : ''}</div>
                <div className='col bg-white px-0 pr-2'>
                  <div className="row mx-0 px-1-env py-2 p-3">
                    <div className='col'>購入数</div><div><div>
                      {this.state.inputCount === 1 ?
                        <img
                          src={`/${this.props.siteId}/iconminus.svg`}
                          alt="マイナス"
                          onClick={this.handleDecrement}
                          style={{ cursor: 'pointer' }}
                        /> : <img
                          src={`/${this.props.siteId}/icon_minus.svg`}
                          alt="マイナス"
                          onClick={this.handleDecrement}
                          style={{ cursor: 'pointer' }}
                        />}
                      <span style={{ margin: '0 10px' }}>{this.state.inputCount}</span>
                      {this.state.bookDetailList.find(a => a.ticket_id === t.ticket_id) && (Number(this.state.bookDetailList.find(a => a.ticket_id === t.ticket_id).count) + Number(this.state.inputCount)) > t.booking_limit ? <img
                        src={`/${this.props.siteId}/iconplus.svg`}
                        alt="プラス"
                        onClick={this.handleIncrement}
                        style={{ cursor: 'pointer' }}
                      /> : <img
                        src={`/${this.props.siteId}/icon_plus.svg`}
                        alt="プラス"
                        onClick={this.handleIncrement}
                        style={{ cursor: 'pointer' }}
                      />}
                    </div>
                    </div>
                  </div>
                </div>
                {/* <div className="text-right mt-2">※4名様迄購入できます</div> */}
                {t.ticket_detail_type.map(detail_type => (
                  <React.Fragment key={detail_type.entry_type}>
                    <div className="text-left row mx-0 px-1-env pt-4">
                      <div className='text-left'>{detail_type.entry_type_name}</div>
                    </div>
                    <div className="col px-0 form-group mt-2">
                      <select className="custom-select select-custom w-100 text-left text-black customer-textbox" aria-label="予約日"
                        value={this.state.selectedDetail?.find(sd => sd.entry_type === detail_type.entry_type)?.entry_data || ""}
                        name={detail_type.entry_type}
                        onChange={this.handleDetailChange}>
                        <option value="">- 選択してください -</option>
                        {t.ticket_detail_data.filter(td => td.entry_type === detail_type.entry_type)
                          .sort((a, b) => parseInt(a.entry_data) - parseInt(b.entry_data))
                          .map(td => (
                            <option key={td.entry_data} value={td.entry_data}>
                              {td.entry_name} {td.entry_note}
                            </option>
                          ))}
                      </select>

                    </div>
                  </React.Fragment>
                ))}
                <div>
                </div>
                <div className='h5 text-center font-weight-bold'>料金　{<span className="h3 font-weight-bold" key={t.ticket_id}>{(Number(t.amount) * this.state.inputCount).toLocaleString()}</span>}円（税込）</div>
                <div className="col px-0 py-3">
                  <button
                    onClick={e => this.resetBook()}
                    className="btn-active h5 w-100 py-2 p-3"
                    disabled={
                      (this.state.bookDetailList.find(a => a.ticket_id === t.ticket_id) && Number(this.state.bookDetailList.find(a => a.ticket_id === t.ticket_id).count) + Number(this.state.inputCount)) > t.booking_limit
                      || t.ticket_detail_type.filter(td => td.required).every(td => !this.state.selectedDetail?.find(sd => sd.entry_type === td.entry_type)?.entry_data)
                    }>
                    <div className='row m-0 p-0'>
                      {/* <div className='col-1 m-0 p-0 pl-2 align-self-center'><img src={`/${this.props.siteId}/icon_booking.png`} style={{ width: "2rem" }} alt="ご予約" /></div> */}
                      <div className='col-12 m-0 p-0 text-center align-self-center'><span className="mb-0 h5 font-weight-bold">お支払いへ進む</span></div>
                      <div className='col-1 m-0 align-self-center'></div>
                    </div>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div >
    );
  }

  renderConfirm() {
    var total = null;
    total = CommonBooking.getTotal(this.state.booking_detail, (this.state.booking.refund_total ? this.state.booking.refund_total : 0));
    return (
      <div className="row mx-3 my-3 px-0-env">
        <div className="col px-0 pb-2">
          <div id="bookinputcheck">
            {!this.state.change && <React.Fragment>
              {[constClass.STATUS.REG, constClass.STATUS.PRE].includes(this.state.booking.status) &&
                <h4 className='text-center px-3-env py-2'>
                  予約済
                </h4>
              }
              {this.state.booking.status === constClass.STATUS.FIN &&
                <h4 className='text-center px-3-env py-2'>
                  来店済
                </h4>
              }
              {this.state.booking.status === constClass.STATUS.CCL &&
                <h4 className='text-center px-3-env py-2'>
                  キャンセル済
                </h4>
              }
              {this.state.booking.status === constClass.STATUS.CUPAY &&
                <h5 className='text-center px-3-env py-2 bg-white'>
                  決済期限切れです。<br />
                  お手数ですが、再度やり直してください。
                </h5>
              }
            </React.Fragment>}
            {(!this.state.change && this.state.booking.status === constClass.STATUS.UPAY
              && this.state.booking_detail.findIndex(x => (CommonBooking.checkChangeTime(x.book_date, x.start_time, this.props.settings.CANCEL_LIMIT))) >= 0) &&
              <h4 className='text-center px-3-env py-2 bg-white'>
                決済が完了していません。
                <button className="btn btn-danger" onClick={e => this.submitPayment(this.state.booking.book_id)}>決済へ進む</button>
              </h4>
            }
            <BookingDetailView
              state={this.state}
              cancel_view={false}
              settings={this.props.settings}
              onChangeClick={(state, page) => { this.changeClick(state, page); }}
              checkBookingValid={this.checkBookingValid}
            />
            <div className="row mx-0 mt-3 py-2 pb-0 bg-white">
              <div className="col py-2 font-weight-bold text-green text-right">
                合計
                {(this.state.booking.book_id && this.state.booking.status === constClass.STATUS.UPAY) && "※未決済"}
              </div>
              <div className="col-auto py-2 font-weight-bold text-green text-right">
                {total.toLocaleString()}円<br />
              </div>
            </div>
          </div>
          {("PAY_CANCEL_DETAIL_MESSAGE" in this.props.settings) &&
            <div className='row mx-0 pt-2 pb-0'>
              <div className='col mx-2 text-red'><a href={Common.getExternalUrl(this.props.settings[`PAY_CANCEL_DETAIL_URL`])} target="_blank" rel="noreferrer"><u>※{this.props.settings.PAY_CANCEL_DETAIL_MESSAGE}</u></a></div>
            </div>
          }
        </div>
      </div>
    )
  }

  renderPayment() {
    return (
      <Payment
        siteId={this.props.siteId}
        lineId={this.props.liff_access_token}
        id={this.state.payment_data.id}
        amount={this.state.payment_data.amount}
        inputCount={this.state.inputCount}
        selectedEntry={this.state.selectedEntry}
        selectedExit={this.state.selectedExit}
        bookDate={moment(new Date()).format("YYYY-MM-DD")}
        entrynote={this.state.ticketMaster.filter(item => item.ticket_id === 1).map(t => t.ticket_detail_data.filter(a => a.entry_name === this.state.selectedEntry).map(b => b.entry_note))}
        fee={this.state.payment_data.fee}
        backUrl={this.state.payment_data.backUrl}
        returnUrl={this.state.payment_data.returnUrl}
        checkUrl={this.state.payment_data.checkUrl}
        redirectReturnUrl={this.state.payment_data.redirectReturnUrl}
        abortUrl={`/${this.state.siteId}/`}
        backFunc={this.backPayment}
        returnFunc={this.returnPayment} />
    );
  }

  renderBooklist() {
    return (
      <div className="row mx-3 my-3 px-0-env">
        <div className="col">
          <div id="booklist">
            <div className="booklist">
              <div className="col px-0">
                {this.state.bookingDetailList.filter(item => (item.status === "FIN" || item.status === "CCL") && item.site_id === parseInt(this.props.siteId)).map((item, idx) => (
                  <div key={idx}>
                    <div className="border-bottom border-1">
                      {/* <div className='col-1 m-0 p-0 pl-2 align-self-center'><img src={`/${this.props.siteId}/icon_booking.png`} style={{ width: "2rem" }} alt="ご予約" /></div> */}
                      <div className='m-0 p-0 text-center align-self-center ml-3 pt-1 pb-1'>
                        <span className="mb-0">
                          <div className='frame37 mt-2 w-100'>
                            <div className="font-weight-bold ml-1">{moment(item.book_date).format("YYYY年M月D日(dd)")}</div>
                            <div className="font-weight-bold mr-2">{item.count}名</div>
                            <div className='ml-3 mt-1 text-right custom-box'>{constClass.STATUS_NAME[item.status] === "乗車済" ? <div className='col custom-usebox mr-1'>使用済み</div>
                              : constClass.STATUS_NAME[item.status] === "キャンセル済" ? <div className='custom-cancelbox text-danger'>キャンセル</div> : ""}
                            </div>
                          </div>
                          <div className="text-left font-color-glay ml-1">{this.state.ticketdetailMaster.filter(t => t.entry_type === "E01" && t.ticket_id === item.ticket_id && t.site_id === parseInt(this.props.siteId) && t.entry_data === item.t_booking_detail.find(a => a.entry_type === "E01").entry_data).map(s => s.entry_name)}駅<span className='mx-1'>-</span>
                            {this.state.ticketdetailMaster.filter(t => t.entry_type === "E02" && t.site_id === parseInt(this.props.siteId) && t.ticket_id === item.ticket_id && t.entry_data === item.t_booking_detail.find(a => a.entry_type === "E02").entry_data).map(s => s.entry_name)}駅</div>
                          <div className="text-left font-color-glay ml-1">{this.state.ticketdetailMaster.filter(t => t.entry_type === "E01" && t.ticket_id === item.ticket_id && t.site_id === parseInt(this.props.siteId) && t.entry_data === item.t_booking_detail.find(a => a.entry_type === "E01").entry_data).map(s => s.entry_note)}<span className='mx-1'>-</span>
                            {this.state.ticketdetailMaster.filter(t => t.entry_type === "E02" && t.site_id === parseInt(this.props.siteId) && t.entry_data === item.t_booking_detail.find(a => a.entry_type === "E02").entry_data).map(s => s.entry_note)}</div>
                          <div className="text-left font-color-glay mb-2 ml-1">{item.booking_t_payment.some(p => parseInt(p.history_no) === 1 && p.payment_type === "credit") ? "クレジットカード" : item.booking_t_payment.some(p => parseInt(p.history_no) === 1 && p.payment_type === "paypay") ? "PayPay" : ""}:{Math.floor(item.total).toLocaleString()}円</div>
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderBookconfirm() {
    const squares = ['square', 'square1', 'square2'];
    return (
      <div className="row mx-3 my-3 px-0-env">
        <div className="col">
          <div id="bookconfirm">
            <div>
              {this.state.bookingDetailList.filter(t => t.book_id === this.props.bookId && t.site_id === parseInt(this.props.siteId)).map(t =>
                <div key={t.book_id}>
                  {(t.status === "FIN" && t.book_date === moment(new Date()).format("YYYY-MM-DD")) ?
                    <div className='text-center'>チケットを使用しました<br />本画面をスタッフにお見せください</div> : ""}
                  {t.status === "REG" && this.state.ticketMaster.filter(m => m.site_id === parseInt(this.props.siteId) && m.ticket_id === t.ticket_id).some(x => moment(x.cancellable_until, ['HH:mm:ss'], true).isBefore(moment())) ? <div className='text-center text-danger mb-2'>払い戻し時刻を過ぎたため、払い戻し不可</div> : ""}
                  {(t.book_date !== moment(new Date()).format("YYYY-MM-DD"))
                    ? "" :
                    t.status !== "CUPAY" ?
                      <div className='bg-white ticket-confirm text-center align-self-center px-0 ticket'>
                        {/* <img className="w-100 logo-img" src={`/${this.props.siteId}/logo2.svg`} alt="ロゴ" /> */}
                        <div className="frame147 pt-3 ml-3 w-100">
                          {/* <img src={`/${this.props.siteId}/logo97.svg`} alt="ロゴ" /> */}
                          <div className='col text-left h4 font-weight-bold'>{this.state.ticketMaster.find(m => m.site_id === parseInt(this.props.siteId) && m.ticket_id === t.ticket_id)?.ticket_name}</div>
                          <div className='col-auto text-right ticket-fee mr-5'>&yen;{Math.floor(t.total).toLocaleString()}</div><br />
                        </div>
                        <div className="frame147 pt-2 ml-3">
                          <div className="col text-left h4 font-weight-bold">
                            <span className="bookconfirm-month">{moment(t.book_date).format('M')}</span>月
                            <span className="bookconfirm-day">{moment(t.book_date).format('D')}</span>日
                          </div>
                          <div className="text-right mr-5"><img className="icon_count align-center mr-2" src={icon_count} alt="ロゴ" /><span className='h3 font-weight-bold'>{t.count}</span></div>
                        </div><div className='ticket-border mr-4 ml-4 mb-2 mt-2'></div>
                        <div> {t.t_booking_detail?.map(bd => (
                          <React.Fragment key={bd.entry_type}>
                            <div key={`${bd.entry_type}`} className='row mx-4'>
                              <div className="col text-left text-primary">
                                {this.state.ticketdetailMaster?.find(t => t.entry_type === bd.entry_type)?.ticket_detail_data_type?.entry_type_name}
                              </div>
                              <div className="col text-left text-primary font-weight-bold">
                                {this.state.ticketdetailMaster?.find(t => t.entry_type === bd.entry_type)?.entry_name}
                              </div>
                            </div>
                          </React.Fragment>
                        ))}
                          {/* 
                          <div key={item}>
                            <div className='frame144 col' style={{ display: 'flex', alignItems: 'center' }}>
                              <div style={{ flex: 1 }}>
                                {this.state.ticketdetailMaster
                                  .filter(t => t.entry_type === "E01" && t.site_id === item.site_id && t.ticket_id === item.ticket_id && t.entry_data === item.t_booking_detail.find(a => a.entry_type === "E01")?.entry_data)
                                  .map(s => (
                                    <div key={`E01-${s.entry_data}`} className='col mt-2'>
                                      <div className="text-primary text-left">{s.entry_name}</div>
                                      <div className="text-primary h4 font-weight-bold text-left">{s.entry_note}</div>
                                    </div>
                                  ))}
                              </div>

                              <span className='text-center mt-2'>→</span>

                              <div style={{ flex: 1 }}>
                                {this.state.ticketdetailMaster
                                  .filter(t => t.entry_type === "E02" && t.site_id === parseInt(this.props.siteId) && t.entry_data === item.t_booking_detail.find(a => a.entry_type === "E02")?.entry_data)
                                  .map(s => (
                                    <div key={`E02-${s.entry_data}`} className='col mt-2'>
                                      <div className="text-primary text-right">{s.entry_name}</div>
                                      <div className="text-primary h4 font-weight-bold text-right">{s.entry_note}</div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                        ))} */}
                        </div>< br />
                      </div> : ""
                  }
                  {(t.status === "CCL") ?
                    <div className="frame151">
                      <div>
                        <div className="my-3">
                          <div className='h4 text-center mb-1 text-danger font-weight-bold'>
                            キャンセルされました
                          </div>
                        </div>
                      </div>
                    </div> :
                    (t.status === "FIN") ?
                      <div className="frame151">
                        <div className='text-center mb-1'>
                          使用時刻　{moment(t.upd_date).format("YYYY/MM/DD kk:mm")}
                        </div>
                        <div className="row frame64 d-flex align-self-center text-align-center text-center">
                          {squares.map((square, index) => (
                            <div
                              key={index}
                              className={`${square} ml-2 mr-2 ${2 - index === this.state.activeIndex ? 'square-blue' : ''}`}
                            ></div>
                          ))}
                          <span className='ml-2 mr-2 h4 font-weight-bold text-center mt-1'>利用中</span>
                          {squares.slice().reverse().map((square, index) => (
                            <div
                              key={index + 3}
                              className={`${square} ml-2 mr-2 ${index === this.state.activeIndex ? 'square-blue' : ''}`}
                            ></div>
                          ))}
                        </div>
                        <div className='text-center'>
                          現在時刻　{this.state.currentTime}
                        </div>
                      </div>
                      :
                      (t.status === "OVER") ?
                        <div className="frame151">0
                          <div>
                            <div className='text-center mb-3'>
                              ご乗車の際は、<br />『チケットを使用する』を押して<br />表示される画面を駅係員にご提示ください。
                            </div>
                            <div className="my-3">
                              <div className='text-center mb-1 text-danger font-weight-bold'>
                                期限切れ
                              </div>
                              <div className="h3 text-center font-weight-bold">
                                未使用
                              </div>
                              <div className='text-center'>
                                現在時刻　{this.state.currentTime}
                              </div>
                            </div>
                          </div>
                        </div>
                        :
                        (t.status === "CUPAY") ?
                          <div className="mt-4">
                            <div>
                                <div className=' h3 text-center mb-1 text-danger font-weight-bold'>
                                  決済期限切れ
                                </div>
                                <div className="h5 mt-3 text-center">
                                  お手数ですが、<br />再度やり直してください。
                                </div>
                              </div>
                          </div>
                          :
                          <div className="frame151">
                            <div>
                              <div className='text-center mb-3'>
                                {Common.getSettingValue(this.props.settings, 'TICKET_USE_NOTICE') && Common.getBrString(Common.getSettingValue(this.props.settings, 'TICKET_USE_NOTICE'))}</div>
                              <div className="ticketusebtn">
                                <button
                                  onClick={async (e) => this.handlemodalclick(t.site_id)}
                                  className={`btn btn-booking w-100 h-100 px-2 text-white`}>チケットを使用する
                                </button>
                              </div>
                              <div>
                                <button
                                  onClick={async (e) => this.handlecancelmodalclick(t.site_id, t.book_date, t.book_id, t.count, t.refund_total, t.total, this.state.ticketMaster.find(m => m.site_id === parseInt(this.props.siteId) && m.ticket_id === t.ticket_id)?.ticket_name)}
                                  disabled={moment(this.state.ticketMaster.find(m => m.site_id === parseInt(this.props.siteId) && m.ticket_id === t.ticket_id)?.cancellable_until, ['HH:mm:ss'], true).isBefore(moment())}
                                  className={`btn text-danger w-100 h-200 py-3 px-2`}>予約をキャンセルする</button>
                              </div>
                            </div>
                          </div>
                  }

                  {Common.getSettingValue(this.props.settings, 'ATTENTION_URL') ?
                      <div className=" d-flex justify-content-center mt-3">
                        <a href={Common.getExternalUrl(Common.getSettingValue(this.props.settings, 'ATTENTION_URL'))} target="_blank" rel="noreferrer">
                          <u className="menu-terms">乗車方法をみる</u>
                        </a>
                      </div>
                      : ""}
                </div>
              )}
            </div>
            {this.state.bookingDetailList.filter(t => t.book_id === this.props.bookId).map(t =>
              <div key={t.book_id}>
                <BookModal
                  isOpen={this.state.modalflag}
                  message={`<div className="text-white"><img src="/${this.props.siteId}/icon4.svg" alt="ロゴ" /><br />チケットを使用しますか？<br />ご使用後はキャンセルができなくなります</div>`}
                  onConfirm={async (e) => this.confirmBooking(t.book_id, t.receipt_num, t.status, t.upd_name)}
                  onClose={this.closeModal}
                  disabled={false}
                  siteId={this.state.modalData.siteId}
                />
                <BookCancelModal
                  isOpen={this.state.cancelmodalflag}
                  onConfirm={async (e) => this.cancelBooking(t.book_id, t.status, t.line_id, t.refund_total, t.upd_name, t.total)}
                  onClose={this.cancelcloseModal}
                  disabled={false}
                  bookDate={this.state.modalData.bookDate}
                  count={this.state.modalData.count}
                  refundTotal={this.state.modalData.refundTotal}
                  siteId={this.state.modalData.siteId}
                  entry_name={this.state.modalData.entry_name}
                  entrynote={this.state.modalData.entrynote}
                  entryName={this.state.modalData.entryName}
                  Total={this.state.modalData.total}
                  ticketName={this.state.modalData.ticketName}
                  ticketDetail={this.state.modalData.ticketDetail}
                />
                <BookCancelFinModal
                  isOpen={this.state.cancelmodalfinflag}
                  onConfirm={this.cancelfincloseModal}
                  disabled={false}
                  bookDate={this.state.modalData.bookDate}
                  count={this.state.modalData.count}
                  refundTotal={this.state.modalData.refundTotal}
                  siteId={this.state.modalData.siteId}
                  entry_name={this.state.modalData.entry_name}
                  entrynote={this.state.modalData.entrynote}
                  entryName={this.state.modalData.entryName}
                  Total={this.state.modalData.total}
                  ticketName={this.state.modalData.ticketName}
                  ticketDetail={this.state.modalData.ticketDetail}
                />
              </div>)}
          </div>
        </div>
      </div >
    );
  }

  handlemodalclick = (siteId) => {
    this.setState({
      modalflag: true,
      modalData: {
        siteId,
      }
    });
  }
  renderTerms(agree) {
    return (
      <div className="terms-body mt-4">
        <div className="terms mt-4">
          <div className="customer-input-600 mb-3">
            <div className="col py-0 px-0 align-self-center text-black" dangerouslySetInnerHTML={{ __html: this.props.settings.TERMS_TITLE }} />
          </div>
          <div className="customer-input-400">
            <div className="col py-0 px-0 align-self-center text-black" dangerouslySetInnerHTML={{ __html: this.props.settings.TERMS_TEXT }} />
          </div>
        </div>
        {agree &&
          <div className="row mx-0 pt-3 pb-3">
            <div className="col text-center p-0">
              <button
                className="button text-black bg-lightwhite mt-3"
                onClick={() => { this.scrollPageTop(); this.submitTerms(); }}>
                同意する
              </button>
            </div>
          </div>
        }
      </div>
    );
  }

  closeModal = () => {
    this.setState({ modalflag: false });
  };
  attentioncloseModal = async () => {
    var data = {
      'site_id': this.state.siteId,
      'line_id': this.props.liff_access_token,
      'register_date': this.props.page === constClass.USERCONFIRMATION ? this.state.my_customer.register_date : new Date(),
    };
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/insert/line/${this.state.my_customer.customer_id}`, data);
      if (!this.state.my_customer.register_date) {
        this.props.history.push(`/${this.state.siteId}/?page=${constClass.USER}`);
      }
    } catch (err) {
      // alert('エラーが発生しました。');
      console.log(err);
    }
    this.setState({ attentionmodalflag: false });
  }

  confirmBook = async () => {
    try {
      const params = {
        line_id: this.props.liff_access_token,
      }
      console.log(params);

      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/train_booking/line_status/`, params);
      this.setState({ modalflag: false });
    }
    catch (error) {
      console.log(error);

    } finally {
      this.setState({ modalflag: false });
      await this.refreshBookData();
      this.props.history.push(`/${this.state.siteId}/?page=${constClass.BOOKCONFIRM}&bookid=${this.props.bookId}`);
    }
  };

  confirmBooking = async (book_id, receipt_num, status, upd_name) => {
    const params = { site_id: this.props.match.params.siteId, line_id: this.props.liff_access_token, book_id: this.props.bookId };
    const bookstatuspromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/train_booking/status/search/`, params);
    const bookingStatus = (await bookstatuspromise).data;

    if (bookingStatus.some(m => m.status === "REG")) {
      try {
        const params = {
          site_id: this.props.match.params.siteId,
          status: constClass.STATUS.FIN,
          line_id: this.props.liff_access_token,
          upd_name: upd_name,
        }
        console.log(params);

        await axios.put(`${process.env.REACT_APP_BACKEND_URL}/train_booking/line_status/${book_id}/${receipt_num}`, params);
        this.setState({ modalflag: false });
      }
      catch (error) {
        console.log(error);

      } finally {
        this.setState({ modalflag: false });
        await this.refreshBookData();
        this.props.history.push(`/${this.state.siteId}/?page=${constClass.BOOKCONFIRM}&bookid=${this.props.bookId}`);
      }
    } else {
      alert('ステータスが変更されています');
      this.setState({ modalflag: false });
      await this.refreshBookData();
    }
  };

  handlecancelmodalclick = (siteId, bookDate, bookId, count, refundTotal, total, ticketName, ticketDetail) => {
    this.setState({
      cancelmodalflag: true,
      modalData: {
        siteId,
        bookDate,
        bookId,
        count,
        refundTotal,
        total,
        ticketName,
        ticketDetail

      }
    });
  }
  cancelcloseModal = () => {
    this.setState({ cancelmodalflag: false });
  };
  cancelfincloseModal = async () => {
    this.setState({ cancelmodalfinflag: false });
    this.setState({ cancelmodalflag: false });
    await this.refreshBookData();
    this.props.history.push(`/${this.state.siteId}/?page=${constClass.MENU}`);
  }

  cancelBooking = async (book_id, status, line_id, refund_total, upd_name, total) => {
    const params = { site_id: this.props.match.params.siteId, line_id: this.props.liff_access_token, book_id };
    const bookstatuspromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/train_booking/status/search/`, params);
    const bookingStatus = (await bookstatuspromise).data;
    if (bookingStatus.some(b => b.status !== 'CCL')) {
      try {
        const data = {
          site_id: this.props.match.params.siteId,
          line_id: this.props.liff_access_token,
          book_id,
          refund_total: total - 100,
          upd_name,
        }

        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/book/line/cancel/`, data);

        this.setState({ modalflag: false });
        this.setState({ cancelmodalfinflag: true });
      }
      catch (error) {
        alert("エラーが発生しました");
        console.log(error);
      } finally {
      }
    } else {
      alert('ステータスが変更されています');
      this.setState({ cancelmodalflag: false });
      await this.refreshBookData();
    }
  };

  historyBack() {
    if (this.props.history.length <= 1 || [constClass.HISTORY, constClass.FINISH, constClass.RECEPT].includes(this.props.page)) {
      this.submitCurrentbooking(null, constClass.MENU);
    } else {
      if (this.props.page === constClass.BOOKCONFIRM) {
        this.props.history.replace(`/${this.state.siteId}/?page=${constClass.MENU}`);
      }
      else if (this.props.page === constClass.BOOKLIST) {
        this.props.history.replace(`/${this.state.siteId}/?page=${constClass.MENU}`);
      }
      else if (this.props.page === constClass.FINISH && this.state.booking.book_id) {
        this.setState({ change: false });
        this.submitCurrentbooking(null, null, null, constClass.HISTORY);
      } else if (this.props.page === constClass.INPUTBIN3) {
        //データ変更を取り消す
        this.setState({
          booking: { ...this.state.set_booking },
          booking_detail: this.state.set_booking_detail.concat(),
          bookCalList: this.state.set_bookCalList,
          bookCalListMessage: this.state.set_bookCalListMessage,
        });
        this.props.history.push(`/${this.state.siteId}/?page=${constClass.BINSELECT}`);
      } else if (this.props.page === constClass.BINSELECT) {
        //データ変更を取り消す
        this.setState({
          booking: { ...this.state.set_booking },
          booking_detail: this.state.set_booking_detail.concat(),
          bookCalList: this.state.set_bookCalList,
          bookCalListMessage: this.state.set_bookCalListMessage,
        });
        this.props.history.push(`/${this.state.siteId}/?page=${constClass.MENU}`);
      } else {
        //データ変更を取り消す
        this.setState({
          booking: { ...this.state.set_booking },
          booking_detail: this.state.set_booking_detail.concat(),
          bookCalList: this.state.set_bookCalList,
          bookCalListMessage: this.state.set_bookCalListMessage,
        });
        this.props.history.goBack();
      }
    }
    this.scrollPageTop();
  }

  renderHeader() {
    return this.renderHeaderMemo(this.props.page, this.historyBack);
  }

  render() {
    return (
      this.state.sleeping ?
        <div className="liff-top">
          <div className="full-noheader" ref={this.pageRef}>
            <div className="row mx-0">
              <div className="col py-4 text-center">
                <img className='w-100' src={`/${this.props.siteId}/logo.png`} alt="booking" />
              </div>
            </div>
            <div className='text-center py-3'>
              {(!(window.liff.isInClient()) && (this.props.settings && "API_LIFF_URL" in this.props.settings)) ?
                <div className="row mx-3 mt-3 mb-3 text-center">
                  <div className="col px-0">
                    <button
                      onClick={e => window.location.replace(this.props.settings.API_LIFF_URL)}
                      className={`btn btn-primary w-100 h-100 py-3 px-2`}>
                      <div className='row m-0 p-0'>
                        <div className='col m-0 p-0 text-center align-self-center'><span className="mb-0 h5 font-weight-bold">LINEで開く</span></div>
                      </div>
                    </button>
                  </div>
                </div>

                : <h5 className='text-white'>{constClass.STOP_MESSAGE[`SITE${this.state.siteId}`]}</h5>
              }
            </div>
          </div>
        </div>
        :
        this.state.ready ?
          <div className={`liff-top ${(this.props.page === undefined || this.props.page === null || this.props.page === '' || this.props.page === constClass.MENU) ? "" : this.props.page === constClass.BOOKCONFIRM ? "bg-blue" : ""}`}>
            <ScrollToTop />
            <React.Fragment>
              {!(this.props.page === undefined || this.props.page === null || this.props.page === '' || this.props.page === constClass.MENU || this.props.page === constClass.PAYMENT) && this.renderHeader()}
              <div className={`page-${(this.props.page === undefined || this.props.page === null || this.props.page === '' || this.props.page === constClass.MENU || this.props.page === constClass.PAYMENT) ? 'full-noheader' : (this.props.page === constClass.PAYMENT) ? 'full' : 'btn'}`} ref={this.pageRef}>
                {(this.props.page === undefined || this.props.page === null || this.props.page === '') &&
                  this.renderTerms(true)
                }
                {(this.props.page === constClass.MENU) &&
                  this.renderMenu()
                }
                {(this.props.page === constClass.USER) &&
                  this.renderUser(true)
                }
                {(this.props.page === constClass.USERCONFIRMATION) &&
                  this.renderUser(false)
                }
                {(this.props.page === constClass.INPUTALERT) &&
                  this.renderInputAlert()
                }
                {(this.props.page === constClass.BINSELECT) &&
                  this.renderBinSelect()
                }
                {(this.props.page === constClass.INPUT) &&
                  this.renderInputCount()
                }
                {(this.props.page === constClass.INPUTBIN3) &&
                  this.renderInputBin3()
                }
                {(this.props.page === constClass.INPUTBIN1) &&
                  this.renderInputBin()
                }
                {(this.props.page === constClass.CONFIRM || this.props.page === constClass.FINISH) &&
                  this.renderConfirm()
                }
                {this.props.page === constClass.PAYMENT &&
                  this.renderPayment()
                }
                {(this.props.page === constClass.BOOKLIST) &&
                  this.renderBooklist()
                }
                {(this.props.page === constClass.BOOKCONFIRM) &&
                  this.renderBookconfirm()
                }
                {this.props.page === constClass.FINISH &&
                  this.renderFinish()
                }
                {this.props.page === constClass.HISTORY &&
                  this.renderBookSelect()
                }
                {(this.props.page === constClass.RECEPTQR || this.props.page === constClass.RECEPT) &&
                  this.renderReceptQr()
                }
                {this.props.page === constClass.CANCEL &&
                  <BookingCancel {...this.props} {...{ refreshBookData: this.refreshBookData }} />
                }
                {this.props.page === constClass.TERMS &&
                  this.renderTerms(false)
                }
              </div>
              {!(this.props.page === undefined || this.props.page === null || this.props.page === '' || this.props.page === constClass.MENU || this.props.page === constClass.PAYMENT || this.props.page === constClass.TERMS) &&
                this.renderBottom()
              }
              {this.state.disabled && <Loading />}
            </React.Fragment>
          </div>
          : <Loading />)
  }

}

export default withRouter(Booking);